import { Box, Chip, Tooltip } from '@mui/material';
import React from 'react';
import { FILTER_EXPRESSIONS, INACTIVE_FALSE_FILTER } from '../../constants/constants';
import AIAdornment from '../AIAdornment';

const getChip = (
    option: Record<string, any>,
    index: number,
    getItemProps: Function,
    getChipKey?: (option: Record<string, any>, index: number) => string,
    getChipSx?: (chipKey: string) => any,
    onChipClick?: (option: Record<string, any>, chipKey: string) => void
) => {
    const chipKey = getChipKey?.(option, index) ?? String(option.id ?? `chip-${index}`);
    const itemProps = getItemProps({ index });
    const handleClick = (event) => {
        itemProps.onClick?.(event);
        onChipClick?.(option, chipKey);
    };

    return (
        <Box component={'span'} key={`tt-${chipKey}`} style={{ display: 'inline-block' }}>
            <Chip
                size="small"
                label={option.label}
                {...itemProps}
                sx={getChipSx?.(chipKey)}
                onClick={handleClick}
            />
        </Box>
    );
};

const getRenderTag = (
    option: Record<string, any>,
    index: number,
    tooltip: string | Function,
    getItemProps: Function,
    getChipKey?: (option: Record<string, any>, index: number) => string,
    getChipSx?: (chipKey: string) => any,
    onChipClick?: (option: Record<string, any>, chipKey: string) => void
) => {
    const tooltipText = typeof tooltip === 'function' ? tooltip(option) : tooltip;
    const chip = getChip(option, index, getItemProps, getChipKey, getChipSx, onChipClick);
    const chipKey = getChipKey?.(option, index) ?? String(option.id ?? `chip-${index}`);

    return tooltipText ? (
        <Tooltip title={tooltipText} key={`tt-${chipKey}`}>
            {chip}
        </Tooltip>
    ) : (
        chip
    );
};

export const autocompleteCustomRenderMultipleValues = ({
    value,
    tooltip,
    getItemProps,
    getChipKey,
    getChipSx,
    onChipClick
}) => {
    if (!value.length) {
        return null;
    }

    return value.map((option: Record<string, any>, index: number) =>
        getRenderTag(option, index, tooltip, getItemProps, getChipKey, getChipSx, onChipClick)
    );
};

// Merges the inactive:false filter expression into the given filter when showInactive is false.
// Any existing inactive expression is stripped first to prevent duplicates.
export const withInactiveFilter = (inputFilter, showInactive: boolean) => {
    if (showInactive) {
        return inputFilter;
    }
    const expressions = (inputFilter?.expressions || []).filter(
        (expression) => expression?.field !== FILTER_EXPRESSIONS.inactive
    );
    return {
        ...(inputFilter || {}),
        expressions: [...expressions, ...INACTIVE_FALSE_FILTER.expressions]
    };
};

export const getAIAdornment = (inputParams, val, isAIExtractedValue) => {
    const adornment = inputParams.InputProps.startAdornment;
    if (val && isAIExtractedValue) {
        return (
            <>
                <AIAdornment />
                {adornment}
            </>
        );
    }
    return adornment;
};
